/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
// import '../Assets/Sass/components/login.scss';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import LoginHooks from "../hooks/LoginHooks";
import styled from "styled-components";
import {Link} from "react-router-dom";
import CONSTANTS from "../constants";
import {AlertToast} from "../Components/AlertToast";
import {FooterTipsRegisterComponents} from "./RecoveryPassword";

export const Forms = styled.form`
  border-radius: 0px 50px 0px 50px;
  box-shadow: 10px 10px 10px 5px #080808;
  margin-top: 10px;
`;

export const SubmitInput = styled.input`
  padding: 10px;
  height: 50px;
  border: none;
  border-radius: 8px;
  background: ${(props) => (props.primary ? "palevioletred" : "#9b59b6")};
  cursor: ${(props) => (props.loading ? "progress" : "pointer")} !important;
  color: #fff;
  margin: 20px;
  font-weight: bold;
`;

function Login() {
  const { handleLogin, loading } = LoginHooks();

  return (
    <div className="container d-flex mt-5 flex-column align-items-center">

      <img src="logo.png" width={180} alt="Codivas" className="mb-3" />
      <div>


      <Forms
        onSubmit={handleLogin}
        className=" d-flex flex-column border p-5 "
        name="login"
        style={{ height: "fit-content", textAlign: "center" }}
      >
        <div
          class="form-group d-flex flex-column justify-content-between"
          style={{
            height: "fit-content",
            border: "1px solid transparent",
            gap: "16px",
          }}
        >
          <AlertToast position="top-center"/>
          <p className="text-muted">Bem Vinda CODIVA!</p>
          <input
            className="form-control"
            type="email"
            name="email"
            placeholder="E-mail"
            required
          />
          <input
            className="form-control"
            type="password"
            name="password"
            placeholder="Password"
            required
          />

            <Link to={CONSTANTS.APP.RECOVERY} className="nav-link d-inline">
              Esqueceu a senha?
            </Link>
          <SubmitInput
              type="submit"
              name=""
              loading={loading}
              value={loading ? "aguarde..." : "Login"}
          />
          <FooterTipsRegisterComponents
              label={"Não tem conta?"}
              labelLink={"Cadastre-se agora!"}
              to={CONSTANTS.APP.REGISTER}
          />
        </div>

        <ul className="social-network social-circle d-flex mt-2 justify-content-around">
          <li>
            <a
              href="https://github.com/Codivas"
              className="icoGitHub"
              title="Github"
            >
              <FontAwesomeIcon icon={["fa", "code-branch"]} />
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/as.codivas/"
              className="icoInstagram"
              title="Instagran"
            >
              <FontAwesomeIcon icon={["fa", "camera-retro"]} />
            </a>
          </li>
        </ul>
      </Forms>
      </div>
    </div>
  );
}

export default Login;
